export default {
  patrimony: {
    actionLabel: 'Utilisez ce levier et développer votre patrimoine',
    leversIndicators: {
      title: "Vos",
      focusWord: "leviers",
      restTitle: "clés",
      availableSaving: {
        hoverDescription: "Votre épargne disponible correspond à la somme de tous vos livrets d'épargne disponibles immédiatement (sous 48h) par exemple : Livret A, Livret de développement durable et solidaire, Livret d'épargne populaire, Compte sur livret, Compte épargne logement..",
      },
      borrowingCapacity: {
        hoverDescription: "Votre capacité d'emprunt, aussi appelée capacité d'endettement, correspond au montant maximum que vous pouvez emprunter pour financer vos projets. Elle se calcule en fonction de vos revenus et de vos charges (dont les remboursement des éventuels crédits en cours)",
      },
      monthlyAvailableSaving: {
        hoverDescription: "Votre capacité d'épargne correspond à la différence entre la somme de tous vos revenus mensuels (salaires, revenus fonciers, pensions...) et de toutes vos charges mensuelles (mensualités de crédits, loyers, primes d'assurances, impôts et taxes...). Cette somme peut être allouée à une épargne régulière.",
      },
    },
    projectionChart: {
      title: "Développer votre",
      focusWord: "patrimoine",
    },
    appointments: {
      buttonLabel: "Voir les créneaux disponibles",
      title: "Prendre rendez-vous avec votre conseiller",
    },
    leversInformation: {
      title: "Quels",
      focusWord: "leviers",
      rest: "utiliser pour développer mon patrimoine?",
      content: "Votre capacité d'emprunt, votre épargne disponible et votre capacité d'épargne régulière constituent des leviers qui vous permettent d'envisager de développer votre patrimoine. Ces leviers permettent de développer son patrimoine immobilier et financier, sans oublier la mise en place de capitaux décès pour protéger vos proches.",
    },
    projectionPatrimony: {
      title: "Comment ça marche ?",
      focusWord: "La projection de votre patrimoine",
      rest: "",
      content: "Ce graphique est une simulation de votre patrimoine financier et immobilier sur 20 ans, tenant compte de vos remboursements de crédits, de votre épargne programmée et d'une performance en corrélation avec l'exposition en risque de vos placements. \n" +
        "Cette simulation est réalisée en fonction de plusieurs scénarios du plus favorable au plus défavorable.",
    },
    patrimonyDevelopmentLevers: {
      title: "Comment ça marche ?",
      focusWord: "Les indicateurs clés de développement patrimonial",
      rest: "",
      content: "Développez votre patrimoine et protégez vos proches grâce à trois leviers principaux : l’investissement immobilier, l’adhésion à un contrat de prévoyance, et les placements financiers. Vous avez la possibilité de choisir un, deux ou les trois leviers selon vos objectifs. En fonction de votre sélection, la préconisation des montants à investir est automatiquement ajustée."
    },
    financialInvestmentRiskLevel: {
      noRecommendationBtn: "Rendez-vous en agence",
    },
    bottomText: 'L\'illustration graphique présentée ci-dessus ne constitue pas un indicateur fiable quant aux performances futures de vos investissements. Elle a seulement pour but d\'illustrer les mécanismes de votre investissement sur la durée de placement. Cette illustration s\'appuie sur les historiques de portefeuilles modèles diversifiés composés de fonds monétaire et de fonds obligataire de la zone Euro, de fonds action mondiales et européennes avec pour référence l\'indice MSCI Emerging Markets Free et l\'indice MSCI Europe, d\'un fonds indiciel sur l\'indice MSCI Emerging Markets et de fonds Private Equity. L\'évolution de la valeur de votre investissement pourra s\'écarter de ce qui est affiché, à la hausse comme à la baisse. Les gains et les pertes peuvent dépasser les montants affichés, respectivement, dans les scénarios les plus favorables et les plus défavorables. En poursuivant votre navigation, vous reconnaissez avoir pris connaissance de cet avertissement, et l\'avoir compris. ',
  },
}
